import React from 'react';
import { Paper, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import SaleClock from './SaleClock';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        paddingTop: 5,
        paddingBottom: 5,
        borderBottomStyle: "solid",
        borderBottomColor: theme.lpb.borderColor,
        borderBottomWidth:1
    },
    paper: {
        display:"flex",
        fontWeight: '400',
        fontSize: 14,
        color: theme.lpb.header.fontBlack,
        alignItems: 'center',
        justifyContent:'center',
        height: 70,
        borderRadius:0
    },
    container: {
        display: "flex-grow",
    },
    logo: {
        paddingRight:40
    },
    sellerName: {
        textAlign: 'left',
        display: "flex",
        alignItems:"center"
    },
    clockGrid: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems:"center"
    },
    clockPicture: {
        paddingRight: 5,
    },
    clock: {
        width: 215,
        paddingTop:10
    },
    logImage: {
        height: "inherit",
        width: "inherit"
    }
}));

function SaleDisplayHeader(props) {
    const classes = useStyles();

    const roomText = props.roomNo && !props.saleDisplayType ? ` | Room ${props.roomNo}` : '';
    const sellerName = props.selectedRow && (props.selectedRow.broker) ? props.selectedRow.broker : 'Not selected';
    const imageName = `./img/${props.selectedRow.brokerId}.png`; 
    const emptyImage = (el) => { el.target.src = `./img/emptylogo.png`; }; 
    const watchPict = `./img/tech/history.png`;
    const departmentName = props.selectedRow && (props.selectedRow.departmentName) ? props.selectedRow.departmentName : 'Not selected';
        
    return (
        <div className={classes.root}>
            <Grid container spacing={0} className={classes.container}>
                <Grid item xs={2} className={classes.logo}>
                    <Paper className={classes.paper}>
                        <img src={imageName} className={classes.logImage} onError={emptyImage}/>
                </Paper>
                </Grid>
                <Grid item xs={7} className={classes.sellerName}>
                    <h4>{departmentName}{roomText} </h4>
                </Grid>
  
                <Grid item xs={3} className={classes.clockGrid}>
                    <img src={watchPict} alt="" className={classes.clockPicture}/>
                    <h5 className={classes.clock}><SaleClock /></h5>
                </Grid>
            </Grid>
        </div>
    );
}

export default SaleDisplayHeader;
